import "core-js/modules/es.array.push.js";
import { useWindowScroll } from "@vueuse/core";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
import { useRouter } from "vue-router";
import Bugsnag from "@bugsnag/js";
import { track } from "@/analytics/events";
const router = useRouter();
const toIteraTravelReasons = () => {
  track("ITIRA - Start", {});
  Bugsnag.leaveBreadcrumb('Button clicked');
  setTimeout(() => {
    router.push({
      path: "/itira/travel-reasons"
    });
  }, 500);
};
export default {
  name: "blogNav",
  components: {
    CloudImage: CloudinaryImage
  },
  setup() {
    const {
      y
    } = useWindowScroll();
    return {
      y
    };
  }
};